<template>
    <div class="calculator">
        <div class="form-input">
            <form id="formSimpas" name="formSimpas" method="post">
                <div class="padding">
                    <h2>Input</h2>
                    <div class="row">
                        <div class="info-bubble-one" id="id-one"> <i>i<i>SIMPAS: Available planter series. Contact a Trimble dealer to confirm your planter details.</i></i> </div>
                        <label for="planter">Planter Selection </label>
                        <select id="planter" name="planter"></select>
                    </div>
                    <div class="row">
                        <label for="numrows">Number of Rows</label>
                        <!--<input type="number" id="numrows" name="numrows" max="99" min="6" minlength="1" maxlength="2" value="16" required>-->
                        <select id="numrows" name="numrows">
                            <option value="6">6-Row</option>
                            <option value="8">8-Row</option>
                            <option value="12">12-Row</option>
                            <option value="16">16-Row</option>
                            <option value="24" selected >24-Row</option>
                            <option value="32">32-Row</option>
                        </select>
                    </div>
                    <div class="row">
                        <div class="info-bubble-two" id="id-two"> <i>i<i>Number of years to spread the capital investment across - usable life of equipment may exceed this estimate.</i></i> </div>
                        <label for="numyears"># of Years to Depreciate Purchase </label>
                        <input type="number" id="numyears" name="numyears" max="99" minlength="1" min="1" value="5" required>
                    </div>
                    <div class="row">
                        <label for="numacres"># of Corn Acres Planted Annually</label>
                        <input type="number" id="numacres" name="numacres" max="99999999" min="0" minlength="1" maxlength="8" value="3000" required>
                    </div>
                    <div class="row"><label for="price">Current Price of Corn</label></div>
                    <div class="row split price">
                        <div class="col force-dollarsign">
                            <span class="dollarsign">$</span><input type="number" id="price" name="price" step="0.01" minlength="1" maxlength="6" value="6.00" min="0.01" required>
                        </div>
                        <div class="col">
                            <span>/Bushel</span>
                        </div>
                    </div>
                    <router-link to="/simpas" @click="scrollMeTo('simpas-results')" class="calculate-button">
                        CALCULATE
                    </router-link>
                </div>
            </form>
        </div>

        <div class="form-results" ref="simpas-results">


            <form name="formSimpas" method="post">
                <div class="padding">
                    <h2 id="scrollto">Results</h2>
                    <div class="row"><label for="totalcost">SIMPAS System Cost - TOTAL*</label></div>
                    <div class="row totalcost">
                        <div class="col force-dollarsign">
                            <span class="dollarsign">$</span><input type="number" id="totalcost" name="totalcost" step="0.01" min="0.01" required>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label for="annualcost">Annual Cost of SIMPAS System
                                <div class="details">(SIMPAS System Estimate/Years to Depreciate)</div></label>
                            <input type="text" id="annualcost" class="highlighted" name="annualcost" readonly>
                        </div>
                    </div>
                    <div class="row">
                        <label for="peracrecost">SIMPAS Cost per Acre Annually
                            <div class="details">(Annual Cost/Acres Planted)</div></label>
                    </div>
                    <div class="row split price">
                        <div class="col">
                            <input type="text" id="peracrecost" class="highlighted" name="peracrecost" readonly>
                        </div>
                        <div class="col">
                            <span>/Acre</span>
                        </div>
                    </div>
                </div>
                <footer>
                    <div class="padding">
                        <div class="row">
                            <label for="annualbushelsperacre">
                                Annual Bushels/Acre Increase Needed to Offset System Costs**
                                <div class="details">(Annual Cost Per Acre/Price of Corn)</div>
                            </label>
                        </div>
                        <div class="row split">
                            <div class="col">
                                <input type="text" id="annualbushelsperacre" class="highlighted lg" name="annualbushelsperacre" readonly>
                            </div>
                            <div class="col">
                                <span>Bushels/Acre</span>
                            </div>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </div>
    <p class="small">*This total is an estimate only, not a quote. It does not include a display or associated licenses. Additional accessories, installation, calibration, and other farmer-specific services can be quoted separately by participating Trimble<sup class="reg">®</sup> Dealers. Please visit <a href="https://www.simpas.com/dealer" target="_blank">www.simpas.com/dealer</a>  to find a Trimble Dealer who can provide a quote for purchasing a system.</p>
    <p class="small">**The additional bushel/acre estimate is the increase needed across all of the SIMPAS-applied Solutions applied through the SIMPAS system to cover the initial investment.</p>
    <p class="small copyright">&copy;{{new Date().getFullYear()}} AMVAC Chemical Corporation. All Rights Reserved. | <a href="//www.amvac.com/privacy-statement"  target="_blank">Privacy Policy</a> | <a href="//www.simpas.com/trademarks/"  target="_blank">Trademarks</a></p>
    

</template>
<script>
export default {
    show: 'SimpasForm',
    methods: {
        scrollMeTo(refName) {
            // Get current location's distance from the top of the page
            const position = window.pageYOffset;
            // Get an element's distance from the top of the page
            const getElemDistance = function ( elem ) {
                let location = 0;
                if (elem.offsetParent) {
                    do {
                        location += elem.offsetTop;
                        elem = elem.offsetParent;
                    } while (elem);
                }
                return location >= 0 ? location : 0;
            };
            const elem = this.$refs[refName];
            const location = getElemDistance( elem );
            window.scrollTo({
                top: location,
                behavior: 'smooth'
            });
            console.log(location);
        }
    },
    mounted: function() {

    document.querySelector("nav").classList.add('link-home');
    // document.querySelector('nav a').addEventListener('click', function (el) {
    //     event.preventDefault();
    //     history.back();
    // });
    document.querySelector(".home").classList.remove('smartbox-view');
    document.querySelector(".home").classList.add('simpas-view', 'onload');
    document.getElementById("details-home").classList.remove('active');
    document.getElementById("details-simpas-cta").classList.add('active');


const id1 = document.getElementById("id-one");
id1.addEventListener('click', function (e1) {
    document.querySelector('.info-bubble-two').classList.remove('active');
    document.querySelector('.info-bubble-one').classList.toggle('active');
    e1.preventDefault();
}, false);

const id2 = document.getElementById("id-two");
id2.addEventListener('click', function (e2) {
    document.querySelector('.info-bubble-one').classList.remove('active');
    document.querySelector('.info-bubble-two').classList.toggle('active');
    e2.preventDefault();
}, false);



/*
    SIMPAS Calculator data and formulas based on provided spreadsheet:
    SIMPAS-SB+ ROI Calculator Framework - Dec 3 2020.xlsx
*/

const universalCosts = [
    {
        name: "System Installation Kit - ALL",
        value: 1500.00
    },
    {
        name: "GFX-750 Display Kit",
        value: 6320.00
    },
    {
        name: "System Cabling-Calibration - 0-12 Rows",
        value: 975.00
    },
    {
        name: "System Cabling-Calibration - 13-16 Rows",
        value: 1100.00
    },
    {
        name: "System Cabling-Calibration - 17-24+ Rows",
        value: 1850.00
    }
];

const universalPerRowCosts = [
    {
        name: "Row Unit Installation Kit",
        value: 1565.00,
        rowOffset: 0
    },
    {
        name: "SIMPAS Granular Meter Kit",
        value: 950.00,
        rowOffset: 0
    },
    {
        name: "SIMPAS RFID Kit",
        value: 360.00,
        rowOffset: 0
    },
    {
        name: "Drop Tube",
        value: 25.00,
        rowOffset: 0
    }
];

const planterSpecificCosts = [
    {
        name: "John Deere Lift Switch",
        value: 50.00
    },
    {
        name: "Case 1200 Lift Switch",
        value: 70.00
    },
    {
        name: "Universal Magnet Lift Switch",
        value: 85.00
    },
    {
        name: "John Deere ME, ME5, EE Ladder Bracket - 2 Rows",
        value: 250.00
    },
    {
        name: "John Deere XP Ladder Bracket - 2 Rows",
        value: 250.00
    },
    {
        name: "Case 1200 Series Ladder Bracket - 2 Rows",
        value: 275.00
    },
    {
        name: "Case 2100 Series Ladder Bracket - 2 Rows",
        value: 275.00
    }
];

const planterSpecificPerRowCosts = [
    {
        name: "Seed Box Row Unit Bracket",
        value: 70.00,
        rowOffset: 0
    },
    {
        name: "John Deere ME, ME5, EE Row Unit Bracket",
        value: 150.00,
        rowOffset: -2
    },
    {
        name: "John Deere XP Row Unit Bracket",
        value: 90.00,
        rowOffset: -2
    },
    {
        name: "Case 1200 Series Row Unit Bracket",
        value: 75.00,
        rowOffset: -2
    },
    {
        name: "Case 2100 Series Row Unit Bracket",
        value: 150.00,
        rowOffset: -2
    }
];

const planters = [
    {
        name: "John Deere ME, ME5, EE Central Fill",
        costs: [
            universalCosts[0],
            universalCosts[1],
            planterSpecificCosts[0],
            planterSpecificCosts[3]
        ],
        perRowCosts: [
            universalPerRowCosts[0],
            universalPerRowCosts[1],
            universalPerRowCosts[2],
            universalPerRowCosts[3],
            planterSpecificPerRowCosts[1]
        ]
    },
    {
        name: "Planter with Seed Boxes",
        costs: [
            universalCosts[0],
            universalCosts[1],
            planterSpecificCosts[2],
        ],
        perRowCosts: [
            universalPerRowCosts[0],
            universalPerRowCosts[1],
            universalPerRowCosts[2],
            universalPerRowCosts[3],
            planterSpecificPerRowCosts[0]
        ]
    },
    {
        name: "John Deere XP Central Fill",
        costs: [
            universalCosts[0],
            universalCosts[1],
            planterSpecificCosts[0],
            planterSpecificCosts[4]
        ],
        perRowCosts: [
            universalPerRowCosts[0],
            universalPerRowCosts[1],
            universalPerRowCosts[2],
            universalPerRowCosts[3],
            planterSpecificPerRowCosts[2]
        ]
    },
    {
        name: "Case 1200 Series Central Fill",
        costs: [
            universalCosts[0],
            universalCosts[1],
            planterSpecificCosts[1],
            planterSpecificCosts[5]
        ],
        perRowCosts: [
            universalPerRowCosts[0],
            universalPerRowCosts[1],
            universalPerRowCosts[2],
            universalPerRowCosts[3],
            planterSpecificPerRowCosts[3]
        ]
    },
    {
        name: "Case 2100 Series Central Fill",
        costs: [
            universalCosts[0],
            universalCosts[1],
            planterSpecificCosts[2],
            planterSpecificCosts[6]
        ],
        perRowCosts: [
            universalPerRowCosts[0],
            universalPerRowCosts[1],
            universalPerRowCosts[2],
            universalPerRowCosts[3],
            planterSpecificPerRowCosts[4]
        ]
    }
];



function calculateLineItemCosts(planterIdx, numRows) {
    const planter = planters[planterIdx];

    const lineItems = {
        planter: planter.name,
        numRows: numRows,
        costs: planter.costs.slice(),
        costsSubTotal: 0.00,
        perRowCosts: planter.perRowCosts.slice(),
        perRowCostsSubTotal: 0.00,
        totalCost: 0.00
    };

    //--- Add system cabling-calibration cost based on number of rows.
    if (numRows <= 12)
        lineItems.costs.push(universalCosts[2]);
    else if (numRows >= 13 && numRows <= 16)
        lineItems.costs.push(universalCosts[3]);
    else if (numRows > 16)
        lineItems.costs.push(universalCosts[4]);

    //--- Calculate per system costs.
    lineItems.costs.forEach(
        function (item) {
            lineItems.costsSubTotal += item.value;
        }
    );

    //--- Calculate per row costs.
    lineItems.perRowCosts.forEach(
        function (item) {
            const numItems = numRows + item.rowOffset;
            const value = item.value * numItems;
            item.numItems = numItems;
            item.subTotal = value;
            lineItems.perRowCostsSubTotal += item.subTotal;
        }
    );

    //--- Calculate total cost.
    //NOTE: totalCost calculation below was commented out and replaced with a calculation based solely on number of rows * a fixed amount. This may be only temporary. -EW
    
    lineItems.totalCost = (numRows * 3000).toFixed(2);

    //lineItems.totalCost = (lineItems.costsSubTotal + lineItems.perRowCostsSubTotal).toFixed(2);

    return lineItems;
}

function calculateTotals(lineItems, totalCost, numYears, numAcres, price) {
    const totals = {
        lineItems: lineItems,
        totalCost: 0.00,
        annualCost: 0.00,
        perAcreCost: 0.00,
        annualBushelsPerAcre: 0.00
    };

    if (totalCost > 0.00 & totalCost !== lineItems.totalCost)
        totals.totalCost = totalCost;
    else
        totals.totalCost = lineItems.totalCost;
    totals.annualCost = (totals.totalCost / numYears).toFixed(2);
    totals.perAcreCost = (totals.annualCost / numAcres).toFixed(2);
    totals.annualBushelsPerAcre = (totals.perAcreCost / price).toFixed(2);

    return totals;
}

// FUNCTIONALITY: ---------------------------------------------------------------------------------

const planterSelect = document.getElementById("planter");
const numRows = document.getElementById("numrows");
const numYears = document.getElementById("numyears");
const numAcres = document.getElementById("numacres");
const price = document.getElementById("price");
const totalCost = document.getElementById("totalcost");

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


function calculate(useTotalCost) {
    const lineItems = calculateLineItemCosts(+planterSelect.value, +numRows.value);
    //console.log(lineItems);

    let tc = 0.00;
    if (useTotalCost)
        tc = +totalCost.value;

    const totalCosts = calculateTotals(lineItems, tc, +numYears.value, +numAcres.value, +price.value);
    //console.log(totalCosts);
    totalCost.value = totalCosts.totalCost;   
    const annualCost = document.getElementById("annualcost");
    annualCost.value = '$' + numberWithCommas(totalCosts.annualCost);
    const perAcreCost = document.getElementById("peracrecost");
    perAcreCost.value = '$' + numberWithCommas(totalCosts.perAcreCost);
    const annualBushelsPerAcre = document.getElementById("annualbushelsperacre");
    annualBushelsPerAcre.value = numberWithCommas(totalCosts.annualBushelsPerAcre);
}
const numInputs = document.querySelectorAll('input[type=number]')
numInputs.forEach(function(input) {
    input.addEventListener('change', function(e) {
    if (e.target.value == '' || e.target.value == 0) {
        e.target.value = e.target.min;
        calculate(false);
    }
    })
})
const calcForm = document.getElementById("formSimpas");
if (calcForm !== null) {

    planters.forEach(
        function (item, index) {
            const option = document.createElement("option");
            option.text = item.name;
            option.value = index;
            planterSelect.add(option);
        }
    );

    /*calcForm.addEventListener("submit",
        function (e) {
            e.preventDefault();
            calculate();
        }
    );*/

    calculate(false);

}
planterSelect.addEventListener("change", function () { calculate(false); });
numRows.addEventListener("input", function () { calculate(false); });
numYears.addEventListener("input", function () { calculate(false); });
numAcres.addEventListener("input", function () { calculate(false); });
price.addEventListener("input", function () { calculate(false); });
totalCost.addEventListener("input", function () { calculate(true); });
    }
}
</script>
